import { Row, Col, Input, Button, Form, Checkbox, Modal } from "antd";
import Icon from "@mdi/react";
import axios from "axios";
import { mdiArrowLeft } from "@mdi/js";
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import environment from "../../../../../config/environment";

const ConsentPage = () => {
  const location: any = useLocation()
  const history = useHistory();
  const [isCheckAcceptance, setIsCheckAcceptance] = useState(false);
  const [isCheckDeacceptance, setIsCheckDeacceptance] = useState(false);
  const dt = new Date();
  const { t } = useTranslation(namespaces.pages.daolinv);

  const checkAcceptance = (e) => {
    setIsCheckAcceptance(e.target.checked);
    console.log(`checked Consent Acceptance = ${isCheckAcceptance}`);
  };

  const checkDeacceptance = (e) => {
    setIsCheckDeacceptance(e.target.checked);
    console.log(`checked Consent Deacceptance= ${isCheckDeacceptance}`);
  };

  function onSubmit() {
    const url = `${environment?.baseApi}/updateConsentRmf`
    axios.post(url, {
      customerName: location?.state?.customerName,
      customerId: location?.state?.customerId,
      taxId: location?.state?.taxId,
      taxYear: location?.state?.taxYear,
      accept: isCheckAcceptance === true ? "Y" : "N",
      phoneNumber: location?.state?.phoneNumber,
    })
      .then(res => {
        if (res.status === 200) {

        } else {
          Modal.error({
            title: t("popup_error_title"),
            content: t("popup_error_content"),
            icon: '',
            onOk() {
              console.log('OnOKay');
            },
          });
        }

      }).catch((error) => {
        Modal.error({
          title: t("popup_error500_title"),
          content: t("popup_error500_content"),
          icon: '',
          onOk() {
            console.log('OnOKay');
          },
        });
        console.error('catch error', error);
      });


    history.push({
      pathname: "/contents/daolInv/consentRMF/finish",
      state: {
        customerName: location?.state?.customerName,
        customerId: location?.state?.customerId,
        taxId: location?.state?.taxId,
        taxYear: location?.state?.taxYear,
        accept: isCheckAcceptance === true ? "Y" : "N",
      },
    });

  }

  useEffect(() => {
  }, [location]);

  return (
    <>
      <div className="home-page">
        {console.log("isCheckAcceptance", isCheckAcceptance)}
        <div className="container">
          <Row className="container-main row">
            <div className="content-left col-sm-5">
              <a onClick={() => history.push("/contents/daolInv/consentRMF/otp")}>
                <Icon path={mdiArrowLeft} size="30" color="#FFFFFF" />
              </a>
              <div className="info-left">
                <p className="text-center text-header">
                  {t("consent_title")}
                </p>
                <p className="content-sub">
                  {t("consent_text_descrip")}
                </p>
              </div>
            </div>
            <div className="content-right col-sm-7">
              <p className="text-center text-header">
                {t("consent_descrip_header")}
              </p>
              <p className="details-head">
                <strong>{location?.state?.customerName}</strong> {t("consent_descrip_p1")} <strong>{location?.state?.taxId}</strong>
              </p>

              <div className="box-consent">
                <div>
                  {isCheckDeacceptance === true ? (
                    <Checkbox className="checkbox" disabled>
                      {t("consent_check_accept")}
                    </Checkbox>
                  ) : (
                    <Checkbox className="checkbox" onChange={checkAcceptance}>
                      {t("consent_check_accept")}
                    </Checkbox>
                  )}
                  <p className="consent-tax">
                    {t("consent_descrip_p2")} {location?.state?.taxYear} {t("consent_descrip_p3")}
                  </p>
                </div>

                <p className="check-deaccept">
                  {isCheckAcceptance === true ? (
                    <Checkbox className="checkbox" disabled>
                      <u>{t("consent_check_deaccept")}</u> {t("consent_check_deaccept_1")}
                    </Checkbox>
                  ) : (
                    <Checkbox className="checkbox" onChange={checkDeacceptance}>
                      <u>{t("consent_check_deaccept")}</u> {t("consent_check_deaccept_1")}
                    </Checkbox>
                  )}
                </p>
              </div>

              <Row className="container-button col-button">
                <Col span={12}>
                  {isCheckAcceptance === true ||
                    isCheckDeacceptance === true ? (
                    <Button type="primary" onClick={onSubmit}>
                      {t("btn_confirm")}
                    </Button>
                  ) : (
                    <Button type="primary" disabled>
                      {t("btn_confirm")}
                    </Button>
                  )}
                </Col>
                <Col span={12}>
                  <Button className="back-page" href="https://www.daolinvestment.co.th/home">
                    {t("btn_backto_home")}
                  </Button>
                </Col>
              </Row>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};
export default ConsentPage;
